import { Component, EventEmitter, Output, inject } from '@angular/core';
import { AccessibilityBG, AccessibilityCharType, AccessibilitySizeSteps } from 'src/index';
import { ViewerPostMessageService, ViewerService } from 'src/index/services.index';
import { Accessible } from '../../shared/mixins/accessible.mixin';

@Component({
    selector: 'meta-viewer-accessibility',
    templateUrl: './viewer-accessibility.component.html',
    styleUrls: ['./viewer-accessibility.component.css'],
})
export class ViewerAccessibilityComponent extends Accessible {
    public viewerPostMessageService = inject(ViewerPostMessageService);
    public viewerService = inject(ViewerService);
    @Output() doClose = new EventEmitter();

    override verticalNavSelector = 'button, input[type="radio"]:checked';
    override horizontalNavSelector = 'input[type="radio"]';

    $accessibilitySettings = this.viewerService.$accessibilitySettings;

    onChangeBackground(backgroundColor: AccessibilityBG) {
        this.$accessibilitySettings.update(as => ({ ...as, background: backgroundColor }));
        this.viewerPostMessageService.postMessage('setAccessibilityStyle', this.$accessibilitySettings());
    }


    onChangeSize(size: AccessibilitySizeSteps) {
        this.$accessibilitySettings.update(as => ({ ...as, size }));
        this.viewerPostMessageService.postMessage('setAccessibilityStyle', this.$accessibilitySettings());
    }

    onChangeCharFamily(family: AccessibilityCharType) {
        this.$accessibilitySettings.update(as => ({ ...as, family }));
        this.viewerPostMessageService.postMessage('setAccessibilityStyle', this.$accessibilitySettings());
    }

    onChangeLineSpacing(line: AccessibilitySizeSteps) {
        this.$accessibilitySettings.update(as => ({ ...as, line }));
        this.viewerPostMessageService.postMessage('setAccessibilityStyle', this.$accessibilitySettings());
    }

    onClose(): void {
        this.doClose.emit();
    }
}
